// extracted by mini-css-extract-plugin
module.exports = {"root":"footer_root__eGi87","list":"footer_list__3yMhv","item":"footer_item__ufEv_","link":"footer_link__mASHo"};